export function getClientDeviceId() {
  if (typeof window === 'undefined') return null;
  const key = 'client_device_id';
  let id = localStorage.getItem(key);
  if (!id) {
    if (window.crypto && window.crypto.randomUUID) {
      id = window.crypto.randomUUID();
    } else {
      id = 'cli-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }
    localStorage.setItem(key, id);
  }
  return id;
}

export function clearClientDeviceId() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('client_device_id');
}
